import { EmptyState, Stack, Icon, icons } from '@agentisai/design-system';

/**
 * WorkspacePlaceholder — protected '/workspace/*' placeholder. The real
 * workspace route tree (PLAN §5.2) arrives in later stories. For S-E3 this
 * is the landing surface that proves the ?next= round-trip reached a
 * protected route.
 *
 * NOTE: the DS icon registry has no `Compass` glyph (the blessed set is the
 * curated lucide subset in Icon/icons.ts), so we use `icons.Folder` — the
 * closest workspace-shaped glyph that IS in the registry.
 */
export function WorkspacePlaceholder() {
  return (
    <Stack as="main" align="center" justify="center" style={{ minHeight: '70vh', padding: 48 }}>
      <EmptyState
        icon={<Icon as={icons.Folder} size="lg" />}
        title="Workspace coming soon"
        description="This workspace route is a placeholder. The governed workstream shell arrives in a later story."
      />
    </Stack>
  );
}
WorkspacePlaceholder.displayName = 'WorkspacePlaceholder';
